<template>
  <section :class="{ 'pb-0': !singleSlide }">
    <div class="text-center text-white">
      <div class="container mx-auto">
        <div class="mb-4 flex justify-between items-center relative">
          <img
            v-if="singleSlide"
            :src="require('@/assets/Final Aragon.png')"
            alt="right,nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
            class="w-16 animate-bounce md:relative absolute -top-16 md:-top-0 left-0"
          />
          <h2 class="mx-auto text-center" data-aos="zoom-in-down">
            {{ label }}
          </h2>
          <img
            v-if="singleSlide"
            :src="require('@/assets/Girl [Recovered].png')"
            alt="right,nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
            class="w-16 animate-bounce md:relativ absolute -top-16 md:-top-0 right-0"
          />
        </div>
        <p data-aos="zoom-in-up" :data-aos-delay="100">
          {{ caption }}
        </p>
      </div>
      <div
        class="my-16 mx-auto"
        :class="{ 'max-w-lg 2xl:max-w-screen-md mx-auto px-16': singleSlide }"
      >
        <swiper-images-component :items="items" :swiper-props="swiperProps" />
      </div>
    </div>
  </section>
</template>

<script>
import SwiperImagesComponent from "./swiperImagesComponent.vue"

export default {
  name: "SenatorsComponent",
  props: {
    items: { type: Array, default: () => [] },
    label: { type: String, default: "" },
    caption: { type: String, default: "" },
    centerScaled: { type: Boolean, default: false },
    slidesToShow: { type: Number, default: 4 },
  },
  components: { SwiperImagesComponent },
  computed: {
    swiperProps() {
      if (this.singleSlide) {
        return {
          effect: "cards",
        }
      } else {
        return {
          centeredSlides: true,
          effect: "coverflow",
          slidesPerView: this.slidesToShow,
          spaceBetween: 0,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
        }
      }
    },
    singleSlide() {
      return this.slidesToShow === 1
    },
  },
}
</script>
